import { data } from "jquery";
import { Provider } from "../global/Provider-Api";

const provider = new Provider();

class apiSetting {
  // =========================Auth User========================
  async getAuth(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/billing/user/auth_user",
      data: value,
    });
    return dataRes;
  }
  // =========================Company Setting========================

  async getCompanyPkindev(value) {
    ///bill company
    const dataRes = await provider.api({
      type: "POST",
      url: "/billing/company/get_company_pkindev",
      data: value,
      //token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
    //return dataRes,console.log("Pkindev datares :::", dataRes);
  }

  async getCompanyProfile(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/billing/company/get_company_profile",
      data: value,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  ///////////////////////////////////////////////////////////V
  ///////////////////--OMISE SERVICE --////////////////////////V
  ///////////////////////////////////////////////////////////V
  // 1. สร้างลูกค้าใหม่
  async createOmiseCustomer(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/omise/customer/create_customer",
      data: value, // { id_company, name, email, description }
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }

  // 2. ดึงข้อมูลลูกค้า (Retrieve)
  //    ต้องส่งเข้ามาเป็น object { id_company, customer_id }
  async getOmiseCustomer({ id_company, customer_id }) {
    const dataRes = await provider.api({
      type: "GET",
      url: `/omise/customer/get_customer/${id_company}/${customer_id}`,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }

  // 3. อัปเดตข้อมูลลูกค้า (Update)
  //    ต้องส่งเข้ามาเป็น object { id_company, customer_id, data }
  //    เช่น data = { name: "...", email: "...", description: "..." }
  async updateOmiseCustomer(value) {
    const dataRes = await provider.api({
      type: "PUT",
      url: "/omise/customer/update_customer",
      data: value, // { id_company, customer_id, data }
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }

  // 4. ลบลูกค้า (Delete)
  //    ต้องส่งเข้ามาเป็น object { id_company, customer_id }
  async deleteOmiseCustomer({ id_company, customer_id }) {
    const dataRes = await provider.api({
      type: "DELETE",
      url: `/omise/customer/delete_customer/${id_company}/${customer_id}`,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }

  // -------------------------------
  // ฝั่ง Card
  // -------------------------------

  // 1. ดึงบัตรทั้งหมดของลูกค้า
  //    ต้องส่งเข้ามาเป็น object { id_company, customer_id }
  async getOmiseCards({ id_company, customer_id }) {
    const dataRes = await provider.api({
      type: "GET",
      url: `/omise/card/get_cards/${id_company}/${customer_id}`,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }

  // 2. เพิ่มบัตรให้ลูกค้า (Create)
  //    ต้องส่งเข้ามาเป็น object { id_company, customer_id, token }
  async addOmiseCard(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/omise/card/add_card",
      data: value, // { id_company, customer_id, token }
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }

  // 3. อัปเดตบัตรหลักของลูกค้า (Update)
  //    ต้องส่งเข้ามาเป็น object { id_company, customer_id, card_id }
  async updateOmiseCard(value) {
    const dataRes = await provider.api({
      type: "PUT",
      url: "/omise/card/update_card",
      data: value, // { id_company, customer_id, card_id }
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }

  // 4. ลบบัตรของลูกค้า (Delete)
  //    ต้องส่งเข้ามาเป็น object { id_company, customer_id, card_id }
  async deleteOmiseCard({ id_company, customer_id, card_id }) {
    const dataRes = await provider.api({
      type: "DELETE",
      url: `/omise/card/delete_card/${id_company}/${customer_id}/${card_id}`,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }

  ///////////////////////////////////////////////////////////V
  ///////////////////--SUBSCRIPTION--////////////////////////V
  ///////////////////////////////////////////////////////////V
  //OMISE SUBSCCRIPTION
  async omise_create_customer(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/omise/",
      data: value,
    });
    return dataRes;
  }
  //********************PKINDEV*************************//
  async getPkindev(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/subscription/pkindev",
      data: value,
    });
    return dataRes;
  }

  async AddCompany(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/subscription/add_company",
      data: value,
    });

    return dataRes;
  }
  async MapProject(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/subscription/company_project",
      data: value,
    });

    return dataRes;
  }

  //subscription - TermsCondition
  async getTermsCondition(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/subscription/getTermsCondition",
      data: value,
    });
    return dataRes;
  }
  //subscription - PrivacyPolicy
  async getPrivacyPolicy(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/subscription/getPrivacyPolicy",
      data: value,
    });
    return dataRes;
  }
  //subscription - RefundablePolicy
  async getRefundablePolicy(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/subscription/getRefundablePolicy",
      data: value,
    });
    return dataRes;
  }

  //******************** PROJECT For Subscription****************//
  async getProject_sub(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/subscription/project",
      data: value,
    });
    return dataRes;
  }
  async getProject_plan(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/subscription/project_plan",
      data: value,
    });
    return dataRes;
  }
  //******************** Subscription *************************//

  async getSubscriptionPlan(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/subscription/subscription_plan",
      data: value,
    });
    return dataRes;
  }

  ///////////////////////////////////////////////////////////V
  ///////////////////--END SUBSCRIPTION--////////////////////V
  ///////////////////////////////////////////////////////////V

  ///////////////////////////////////////////////////////////V
  ///////////////////--SMART LAW --//////////////////////////V
  ///////////////////////////////////////////////////////////V
  //Company SML
  async getCompanySmartLaw(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/smart_law/company/list",
      data: value,
    });
    return dataRes;
  }

  //params /detail?id_company=2
  async getCompanySmartLaw_detail(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/smart_law/company/detail",
      data: value,
    });
    return dataRes;
  }

  async getCompanySmartLaw_add(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/smart_law/company/add",
      data: value,
    });
    return dataRes;
  }

  async getCompanySmartLaw_update(value) {
    const dataRes = await provider.api({
      type: "PUT",
      url: "/smart_law/company/update",
      data: value,
    });
    return dataRes;
  }

  async getCompanySmartLaw_delete(value) {
    const dataRes = await provider.api({
      type: "DELETE",
      url: "/smart_law/company/delete",
      data: value,
    });
    return dataRes;
  }

  //Organization SML
  async getOrganizationSmartLaw(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/smart_law/organization/list",
      data: value,
    });
    return dataRes;
  }

  async getOrganizationSmartLaw_detail(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/smart_law/organization/detail",
      data: value,
    });
    return dataRes;
  }

  async getOrganizationSmartLaw_add(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/smart_law/organization/add",
      data: value,
    });
    return dataRes;
  }
  //admin

  async adminSmartLaw_add(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/smart_law/admin/add",
      data: value,
    });
    return dataRes;
  }
  ///////////////////////////////////////////////////////////V
  ///////////////////-- Rentaru Rental--/////////////////////V
  ///////////////////////////////////////////////////////////V
  async getCompanySmartLaw_add(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/rentaru/company/add",
      data: value,
    });
    return dataRes;
  }

  // =========================Address=========================
  async countryAddress(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/nationality",
      data: { lang: value },
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }

  async countryAddress2(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/nationality/country",
      data: { lang: value },
    });
    return dataRes;
  }

  async countriesAddress(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/nationality/countries",
      data: { lang: value },
    });
    return dataRes;
  }

  async provinceAddress(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/province",
      data: value,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async districtAddress(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/province/district",
      data: value,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async subdistrictAddress(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/province/sub_district",
      data: value,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }

  //Address แบบไม่ต้องใส่ id ดึงทั้งหมด

  async provinceAddressOption(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/province/provinceOption",
      data: value,
    });
    return dataRes;
  }

  async districtAddressOption(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/province/districtOption",
      data: value,
    });
    return dataRes;
  }

  async subDistrictAddressOption(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/province/sub_districtOption",
      data: value,
    });
    return dataRes;
  }

  // =========================COMPANY PROFILE==========================
    async UpdateCompany(value) {
        const dataRes = await provider.api({
          type: "POST",
          url: "/billing/company/update",   
          data: value,
        });
        return dataRes;
      }





      


  // =========================Project==========================

  // PROJECT ดึงแบบใช้ Project_code------------------**
  async ProjectList(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "billing/project/list",
      data: value,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }

  // PROJECT Add — ใช้ project_code
async AddProject(value) {
  const dataRes = await provider.api({
    type: "POST",
    url: "billing/project/add",
    data: value,
    token: localStorage.getItem("Auth_Token"),
  });
  return dataRes;
}

// PROJECT Delete — ใช้ id_bill_branch
async DelProject(value) {
  const dataRes = await provider.api({
    type: "POST",
    url: "billing/project/delete",
    data: value,
    token: localStorage.getItem("Auth_Token"),
  });
  return dataRes;
}

// PROJECT Available — list projects ที่ enable=1
async AvailableProjects() {
  const dataRes = await provider.api({
    type: "GET",
    url: "billing/project/available",
    token: localStorage.getItem("Auth_Token"),
  });
  return dataRes;
}

// PROJECT Lookup — validate project_code + preview name_company
async LookupProject(value) {
  const dataRes = await provider.api({
    type: "POST",
    url: "billing/project/lookup",
    data: value,
    token: localStorage.getItem("Auth_Token"),
  });
  return dataRes;
}
//--------------------------------------------------//







  async addProject(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "billing/project/add_project",
      data: value,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async getProject(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "billing/project/get_company_project",
      data: { id_bill: value },
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async getProjectInvoice(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "billing/project/get_company_project_invoice",
      data: { id_bill: value },
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async setProject(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "billing/project/set_company_project",
      data: { id_project: value },
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async delProject(value) {
    const dataRes = await provider.api({
      type: "DELETE",
      url: "/billing/project/delete_project",
      data: { id_bill_branch: value },
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  // =========================User==========================
  async getUser(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/billing/user/get_user",
      data: { id_bill: value },
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async getUserEmail(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/billing/user/get_user_all_email",
    });
    return dataRes;
  }
  async addUser(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/billing/user/add_user",
      data: value,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async updateUser(value) {
    const dataRes = await provider.api({
      type: "PUT",
      url: "/billing/user/update_user",
      data: value,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async editUserPass(value) {
    const dataRes = await provider.api({
      type: "PUT",
      url: "/billing/user/update_user_pass",
      data: value,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async delUser(value) {
    const dataRes = await provider.api({
      type: "DELETE",
      url: "/billing/user/delete_user",
      data: { id_user: value },
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async getRole(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/billing/user/get_role",
      data: { id_bill: value },
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async addRole(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/billing/user/add_role",
      data: value,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async editRole(value) {
    const dataRes = await provider.api({
      type: "PUT",
      url: "/billing/user/edit_role",
      data: value,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async delRole(value) {
    const dataRes = await provider.api({
      type: "DELETE",
      url: "/billing/user/delete_role",
      data: { id_role: value },
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async sendMail(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/billing/user/resendemail",
      data: value,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async sendMailRsetPass(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/billing/user/forgetpassword",
      data: value,
    });
    return dataRes;
  }
  async verifyEmail(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/billing/user/verifyemail",
      data: null,
      token: value,
    });
    return dataRes;
  }
  // =========================Payment==========================
  async getPayment(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/billing/payment/get_payment",
      data: { id_bill: value },
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }

  async getPaymentList(value) {
    console.log("ENDPOINT START ::: getPaymentList value :::", value);


    const dataRes = await provider.api({
      type: "GET",
      url: "/billing/payment/get_payment_list",
      data: { id_bill: value },
      token: localStorage.getItem("Auth_Token"),
    });
    console.log("getPaymentList Endpoint :::", dataRes);
    return dataRes;
  }

  async addPayment(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/billing/payment/add_payment",
      data: value,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  
  async deletePayment(value) {
    const dataRes = await provider.api({
      type: "DELETE",
      url: "/billing/payment/delete_payment",
      data: value,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async sendRequest(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/billing/user/send_request",
      data: value,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
  async CreditBank(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/creditbank",
      data: { lang: value },
    });
    return dataRes;
  }

  async CustomerInvoice(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/billing/customer_invoice",
      data: value,
    });
    return dataRes;
  }

  // =========================CONTRACT AGREEMENT==========================
  async ContractAgreement(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/billing/customer_contract",
      data: value,
    });
    return dataRes;
  }


  async ContractAgreement_invocie(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/billing/customer_contract/invoice",
      data: value,
    });
    return dataRes;
  }


  // =========================BILLING SUBSCRIPTION SETTING ==========================
  async BillingSubscriptionSetting(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/billing/subscription_plan",
      data: value,
    });
    return dataRes;
  }


  // =========================SETTING==========================
  async BankPayment(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/billing/customer_invoice/bank_payment",
      data: value,
    });
    return dataRes;
  }

  async BankPaymentSetting(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/billing/setting/bank_payment",
      data: value,
    });
    return dataRes;
  }

  
  async ProjectDetail(value) {  //ใช้ id_project
    const dataRes = await provider.api({
      type: "GET",
      url: "/billing/setting/project",
      data: value,
    });
    return dataRes;
  }

  async NameTitle(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/nametitle",
      data: value,
    });
    return dataRes;
  }

  async WithHoldingTax(value) {
    const dataRes = await provider.api({
      type: "GET",
      url: "/invoice/holding_tax",
      data: value,
    });
    return dataRes;
  }

  async SendOmise(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/billing/payment/omise_charges",
      data: value,
    });
    return dataRes;
  }

  async SendOmiseCustomer(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/billing/payment/omise_customer",
      data: value,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }

  async SendBillSlip(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/billing/payment/add_bill_slip",
      data: value,
    });
    return dataRes;
  }

  async SendBillSlipInvoice(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/billing/payment/add_bill_slip_invoice",
      data: value,
    });
    return dataRes;
  }

  async SendBillSlipContract(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/billing/payment/add_bill_slip_contract",
      data: value,
    });
    return dataRes;
  }

  // ────────────────────────────────────────────────────────────
  // Audit log
  // ────────────────────────────────────────────────────────────

  /**
   * บันทึกว่าผู้ใช้เปิดดูหน้าไหน — เรียกผ่าน useAuditView ตอน mount
   *
   * ยิงแยกจาก request ที่ดึงข้อมูล เพราะ dashboard/invoice/contract ใช้
   * useBillInvoice ตัวเดียวกันและ cache 5 นาที ทำให้แยกไม่ออกว่าเปิดหน้าไหน
   *
   * body:  { page, sub_page }
   * ตอบ 204 ไม่มี body — ไม่ต้องอ่านผล
   */
  /**
   * อ่าน audit log ของบริษัทตัวเอง (เฉพาะคนที่มีสิทธิ์ audit_view)
   *
   * ⚠️ ไม่ส่ง id_bill — backend อ่านจาก token เอง
   *
   * query: { limit, offset, action, result, actor_type, from, to }
   * คืน:   { status, total, limit, offset, rows[] }
   */
  async AuditList(value = {}) {
    const qs = new URLSearchParams();
    Object.entries(value).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") qs.append(k, v);
    });
    const dataRes = await provider.api({
      type: "GET",
      url: `/billing/audit/list?${qs.toString()}`,
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }

  async AuditView(value) {
    const dataRes = await provider.api({
      type: "POST",
      url: "/billing/audit/view",
      data: {
        page: value.page,
        sub_page: value.sub_page ?? null,
      },
      token: localStorage.getItem("Auth_Token"),
    });
    return dataRes;
  }
}

export default new apiSetting();